// import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// // Crypto Redux States
// import { GET_CHARTS_DATA } from "./actionTypes";
// import { apiSuccess, apiFail } from "./actions";

// //Include Both Helper File with needed methods
// // import {
// //     getWeeklyData,
// //     getYearlyData,
// //     getMonthlyData
// // }
// //     from "../../helpers/fakebackend_helper";



export function* watchGetChartsData() {
  // yield takeEvery(GET_CHARTS_DATA, getChartsData);
}

function* dashboardSaga() {
  // yield all([fork(watchGetChartsData)]);
}

export default dashboardSaga;
